import { NgModule } from '@angular/core';
import { DateTimeFormatPipe } from './dateTimeFormat.pipe';
import { DateFormatPipe } from './dateFormat.pipe';
import { KeepHtmlPipe } from './keepHTML.pipe';
import { CurrencyFormat } from './currentcyFormat.pipe';
import { CallRequestPipe } from './callRequest.pipe';
import { GetSvgIconByTypePipe } from './get-svg-icon-by-type.pipe';
import { GetFileTypeByName } from './get-file-type-by-name.pipe';
@NgModule({
    declarations: [
        DateTimeFormatPipe,
        DateFormatPipe,
        KeepHtmlPipe,
        CurrencyFormat,
        GetSvgIconByTypePipe,
        GetFileTypeByName,
        CallRequestPipe
    ],
    imports: [],
    exports: [
        DateTimeFormatPipe,
        DateFormatPipe,
        KeepHtmlPipe,
        GetSvgIconByTypePipe,
        GetFileTypeByName,
        CurrencyFormat,
        CallRequestPipe
    ]
})
export class PipesModule {


}
